import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React from 'react';

import Panel from 'react-bootstrap/lib/Panel';

import {
  faRocket,
  faRuler,
  faList,
  faChartLine,
  faDollarSign,
} from '@fortawesome/free-solid-svg-icons';

import Link from '../../../../../components/Link';
import PageLayout from '../../../../../components/PageLayout';

import ShadowerLink from '../../../../../components/ShadowerLink';

import Navbar from '../../../../../components/Handbook/Navbar';

import s from '../../HandbookPage.scss';

class SessionFlowPage extends React.Component {
  render() {
    return (
      <PageLayout className={s.page}>
        <div className={s.container}>
          <div className={s.navbar}>
            <div className={s.title}>Shadowing Handbook</div>
            <Navbar
              navbarIcon={faRocket}
              navbarSection="Getting Started"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/welcome-to-shadower"
                  >
                    Welcome to Shadower
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/how-shadower-works"
                  >
                    How Shadower Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/working-with-businesses"
                  >
                    Working with Businesses
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/shadowing-guidelines"
                  >
                    Shadowing Guidelines
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faRuler}
              navbarSection="Planning a Session"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/choosing-a-topic"
                  >
                    Choosing a Topic
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/interactivity-level"
                  >
                    Interactivity Level
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/session-type"
                  >
                    Session Type
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/providing-resources"
                  >
                    Providing Resources
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faList}
              navbarSection="Managing a Session"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/expectations"
                  >
                    Expectations
                  </Link>
                  <Link
                    className={cx(s.link, s.active)}
                    to="/handbook/managing-a-session/session-flow"
                  >
                    Session Flow
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/maximizing-your-time"
                  >
                    Maximizing Your Time
                  </Link>
                </div>
              }
              overrideDefault
            />

            <Navbar
              navbarIcon={faChartLine}
              navbarSection="Promoting Your Profile"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/how-the-platform-works"
                  >
                    How the Platform Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/optimizing-your-profile"
                  >
                    Optimizing Your Profile
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/marketing-yourself"
                  >
                    Marketing Yourself
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/how-to-build-a-following"
                  >
                    How to Build a Following
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faDollarSign}
              navbarSection="Earning Revenue"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/earning-revenue/how-payment-works"
                  >
                    How Payment Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/earning-revenue/connecting-with-the-community"
                  >
                    Connecting with the Community
                  </Link>
                </div>
              }
            />

            <Link className={s.newProfileLink} to="/user/profiles/new">
              Create a shadowing profile
            </Link>
          </div>

          <div className={s.explanation}>
            <Panel>
              <Panel.Heading>
                <div>Managing a Session</div>
              </Panel.Heading>
              <Panel.Body>
                <div className={s.handbookTitle}>A guide for experts</div>
                <div className={s.subsectionTitle}>Session Flow</div>

                <img
                  alt="A workshop project"
                  src="/assets/images/handbook/workshop-project2@1280x600.jpg"
                />

                <p>
                  How you structure your session is completely up to you and
                  although the flow will vary depending on factors such as the
                  level of interactivity or number of shadowers, we generally
                  recommend the following as a guide (using an hour-long session
                  as an example).
                </p>

                <div className={s.contentContainer}>
                  <div>
                    <strong>Introduction (10 min)</strong>
                  </div>

                  <p>To begin your session, we recommend you:</p>

                  <ul>
                    <li>Introduce yourself</li>
                    <li>
                      Provide some background information about yourself and
                      your area of expertise
                    </li>
                    <li>Give a quick tour of your workplace</li>

                    <li>
                      Provide an overview of your session and what you hope to
                      accomplish
                    </li>

                    <li>Disseminate any necessary educational resources</li>
                  </ul>
                </div>

                <div className={s.contentContainer}>
                  <div>
                    <strong>Project Overview (10 min)</strong>
                  </div>

                  <p>During this part, we recommend you:</p>

                  <ul>
                    <li>
                      Demonstrate with an example what you hope to accomplish by
                      the end of the session
                    </li>
                    <li>Set up the work project and the necessary tools</li>
                    <li>
                      Provide an overview of what needs to be done and how to do
                      it
                    </li>
                  </ul>
                </div>

                <div className={s.contentContainer}>
                  <div>
                    <strong>Work on the Project (25 min)</strong>
                  </div>
                  <p>During this part, we recommend you:</p>

                  <ul>
                    <li>
                      Begin working, providing answers, explanation,
                      instruction, tips and tricks
                    </li>

                    <li>Pause occasionally to review the previous steps</li>
                  </ul>
                </div>

                <div className={s.contentContainer}>
                  <div>
                    <strong>Discussion (10 min)</strong>
                  </div>
                  <p>Upon completion of the work project, we recommend you:</p>

                  <ul>
                    <li>Review any confusion steps or concepts</li>

                    <li>
                      Discuss with your shadower how they might apply their
                      knowledge to their own projects
                    </li>

                    <li>
                      Critique or analyze your shadower's personal projects
                    </li>
                  </ul>
                </div>

                <div className={s.contentContainer}>
                  <div>
                    <strong>Conclusion (5 min)</strong>
                  </div>
                  <p>To conclude your session, we recommend you:</p>

                  <ul>
                    <li>
                      Provide a recap of your session together and what you
                      accomplished
                    </li>
                    <li>
                      Disseminate any take-home educational resources or
                      projects
                    </li>
                    <li>Discuss shadowing on a regular basis</li>
                    <li>Thank your shadower for participating</li>
                  </ul>
                </div>

                <ShadowerLink
                  className={s.nextLink}
                  to="/handbook/managing-a-session/maximizing-your-time"
                >
                  Next {'>'}
                </ShadowerLink>
              </Panel.Body>
            </Panel>
          </div>
        </div>
      </PageLayout>
    );
  }
}

export default withStyles(s)(SessionFlowPage);
